/**
 * Shared navigation configuration
 * Used by Header and Footer components
 */

export const navigationItems = [
  { name: 'Home', path: '/', icon: 'Home' },
  { name: 'Projects', path: '/project-showcase-technical-case-studies', icon: 'FolderOpen' },
  { name: 'Skills', path: '/technical-skills-journey', icon: 'Code2' },
  { name: 'Playground', path: '/code-laboratory-interactive-playground', icon: 'Terminal' },
  { name: 'Contact', path: '/contact-opportunities', icon: 'Mail' }
];

export const socialLinks = [
  { name: 'GitHub', icon: 'Github', url: 'https://github.com/arvinzojaji' },
  { name: 'LinkedIn', icon: 'Linkedin', url: 'https://linkedin.com/in/arvin-zojaji' },
  { name: 'Email', icon: 'Mail', url: 'mailto:arvin.zojaji@gmail.com' }
];

export const quickLinks = [
  { name: 'Resume/CV', icon: 'FileText' },
  { name: 'Blog', icon: 'BookOpen' },
  { name: 'Newsletter', icon: 'Mail' },
  { name: 'Speaking', icon: 'Mic' }
];

export default navigationItems;
